export default "__VITE_ASSET__960e9952__"